/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_9_PInputs */

const en_terms_9_p = /** @type {(inputs: Terms_9_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These terms are governed by the laws of the Republic of Indonesia. We may update them; material changes are announced before they take effect, and continued use means acceptance.`)
};

const id_terms_9_p = /** @type {(inputs: Terms_9_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketentuan ini tunduk pada hukum Republik Indonesia. Kami dapat memperbaruinya; perubahan penting diumumkan sebelum berlaku, dan penggunaan berkelanjutan berarti penerimaan.`)
};

/**
* | output |
* | --- |
* | "These terms are governed by the laws of the Republic of Indonesia. We may update them; material changes are announced before they take effect, and continued ..." |
*
* @param {Terms_9_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_9_p = /** @type {((inputs?: Terms_9_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_9_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_9_p(inputs)
	return en_terms_9_p(inputs)
});